import { useState, useEffect, useRef } from 'react';
import axios from '../../api/api';
import swal from 'sweetalert';

export default function AuthToken() {
  const inactivityTimer = useRef(null);

  function logoutUser() {
    window.localStorage.removeItem('token');

    swal('Session expired!', 'You have been logged out due to inactivity.', 'info');

    setTimeout(() => {
      window.location.href = '/';
    }, 1000);
  }

  function getToken() {
    const tokenString = window.localStorage.getItem('token');
    const userToken = JSON.parse(tokenString);

    if (userToken && userToken.expiresAt > new Date().getTime()) {
      axios.defaults.headers.common.Authorization = `Bearer ${userToken.data.access_token}`;
      axios.defaults.headers.common['Content-Type'] = 'application/json';

      return userToken?.data.access_token;
    } else {
      window.localStorage.removeItem('token');
      return null;
    }
  }

  const [accessToken, setAccessToken] = useState(getToken());

  const saveToken = (userToken, expirationHours = 20) => {
    const expiresAt =
      new Date().getTime() + expirationHours * 60 * 1000;

    const tokenData = {
      data: userToken.data,
      expiresAt
    };

    window.localStorage.setItem('token', JSON.stringify(tokenData));

    setAccessToken(userToken.data.access_token);
  };

  useEffect(() => {
    getToken();

    // Logout after 30 minutes of inactivity
    const INACTIVITY_TIME = 30 * 60 * 1000;

    const resetTimer = () => {
      if (inactivityTimer.current) {
        clearTimeout(inactivityTimer.current);
      }

      inactivityTimer.current = setTimeout(() => {
        logoutUser();
      }, INACTIVITY_TIME);
    };

    // Events to track user activity
    const activityEvents = [
      'mousemove',
      'mousedown',
      'keydown',
      'scroll',
      'touchstart'
    ];

    // Add listeners
    activityEvents.forEach(event => {
      window.addEventListener(event, resetTimer);
    });

    // Start timer initially
    resetTimer();

    // Optional: Check token expiry every 10 minutes
    const checkTokenInterval = setInterval(() => {
      const token = getToken();

      if (!token) {
        clearInterval(checkTokenInterval);
        logoutUser();
      }
    }, 10 * 60 * 1000);

    return () => {
      if (inactivityTimer.current) {
        clearTimeout(inactivityTimer.current);
      }

      clearInterval(checkTokenInterval);

      activityEvents.forEach(event => {
        window.removeEventListener(event, resetTimer);
      });
    };
  }, []);

  return {
    setAccessToken: saveToken,
    accessToken
  };
}